import { FC } from "react"

import SafeHTMLRenderer from "../../../../safe-html-renderer"
import { formatDateTimeFromISO } from "../../../../../utils"
import { SubscriptionChatMessage } from "../../../../../../types"

interface EngagementChatUserProps {
  messageData: SubscriptionChatMessage
}

const EngagementChatUser: FC<EngagementChatUserProps> = ({ messageData }) => (
  <div className="w-full flex my-1">
    <div className="flex flex-col max-w-[75%]">
      <SafeHTMLRenderer
        text={messageData.message}
        className="bg-white p-3 shadow-md rounded"
      />
      <div className="pt-1 text-xs text-gray-400">
        {formatDateTimeFromISO(messageData.timestamp)}
      </div>
    </div>
  </div>
)

export default EngagementChatUser
